import { IMarcaProduto } from "@/interfaces/IMarcaProduto";
import { createAction } from "@reduxjs/toolkit";

const sync = createAction("MARCA_PRODUTO/sync", (items: IMarcaProduto[]) => ({
  payload: { items },
}));

export const marcaProdutoAction = { sync };
